"use strict";
const { object, string, array } = require('../utils/modifiedYup');
const { formTriggerSchema } = require('./formTriggerSchema');
const { manualTriggerSchema } = require('./manualTriggerSchema');
exports.triggerSchema = object()
    .required()
    .shape({
    stepName: string().required(),
    triggers: array()
        .oneOfSchemas([formTriggerSchema, manualTriggerSchema])
        .defined()
        .min(1),
    contentId: string().uuid(),
    activationId: string().uuid(),
});
//# sourceMappingURL=triggerSchema.js.map